const DISMISS_KEY = 'wapharma:guide:dismissAutoOpen';
const LAST_PACK_KEY = 'wapharma:guide:lastPackId';
const COMPANION_DISMISS_KEY = 'wapharma:guide:companionDismissed';
const SKIPPED_FLOWS_KEY = 'wapharma:guide:skippedFlows';

function scopedKey(base: string, userId: string | undefined): string {
  return userId ? `${base}:${userId}` : base;
}

export function isGuideAutoOpenDismissed(userId: string | undefined): boolean {
  try {
    return localStorage.getItem(scopedKey(DISMISS_KEY, userId)) === '1';
  } catch {
    return false;
  }
}

export function setGuideAutoOpenDismissed(userId: string | undefined, dismissed: boolean): void {
  try {
    const key = scopedKey(DISMISS_KEY, userId);
    if (dismissed) localStorage.setItem(key, '1');
    else localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

/** Whole companion (chip + dock) hidden until reopen. */
export function isCompanionDismissed(userId: string | undefined): boolean {
  try {
    return localStorage.getItem(scopedKey(COMPANION_DISMISS_KEY, userId)) === '1';
  } catch {
    return false;
  }
}

export function setCompanionDismissed(userId: string | undefined, dismissed: boolean): void {
  try {
    const key = scopedKey(COMPANION_DISMISS_KEY, userId);
    if (dismissed) localStorage.setItem(key, '1');
    else localStorage.removeItem(key);
  } catch {
    /* ignore */
  }
}

export function getSkippedFlowIds(userId: string | undefined): string[] {
  try {
    const raw = localStorage.getItem(scopedKey(SKIPPED_FLOWS_KEY, userId));
    if (!raw) return [];
    const parsed = JSON.parse(raw) as unknown;
    return Array.isArray(parsed) ? parsed.filter((x): x is string => typeof x === 'string') : [];
  } catch {
    return [];
  }
}

export function setSkippedFlowIds(userId: string | undefined, flowIds: string[]): void {
  try {
    const key = scopedKey(SKIPPED_FLOWS_KEY, userId);
    if (flowIds.length === 0) localStorage.removeItem(key);
    else localStorage.setItem(key, JSON.stringify([...new Set(flowIds)]));
  } catch {
    /* ignore */
  }
}

export function skipFlowId(userId: string | undefined, flowId: string): void {
  const next = [...getSkippedFlowIds(userId), flowId];
  setSkippedFlowIds(userId, next);
}

export function unskipFlowId(userId: string | undefined, flowId: string): void {
  setSkippedFlowIds(
    userId,
    getSkippedFlowIds(userId).filter((id) => id !== flowId),
  );
}

export function getLastGuidePackId(userId: string | undefined): string | null {
  try {
    return localStorage.getItem(scopedKey(LAST_PACK_KEY, userId));
  } catch {
    return null;
  }
}

export function setLastGuidePackId(userId: string | undefined, packId: string): void {
  try {
    localStorage.setItem(scopedKey(LAST_PACK_KEY, userId), packId);
  } catch {
    /* ignore */
  }
}
